import { render, staticRenderFns } from "./IntelligenceForm.vue?vue&type=template&id=baca3490"
import script from "./IntelligenceForm.vue?vue&type=script&lang=js"
export * from "./IntelligenceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('baca3490')) {
      api.createRecord('baca3490', component.options)
    } else {
      api.reload('baca3490', component.options)
    }
    module.hot.accept("./IntelligenceForm.vue?vue&type=template&id=baca3490", function () {
      api.rerender('baca3490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Intelligence/IntelligenceForm.vue"
export default component.exports